var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.75 240.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.75,0v23.94c-3.08-1.97-6.34-3.68-9.6-4.72-9.49-3.01-18.91-.44-28.41,4.03-9.47,4.47-18.98,10.8-28.45,8.52-9.49-2.28-18.92-13.21-28.41-18.81-9.47-5.6-18.98-5.91-28.45,1.73C12.27,19.64,6.14,27.94,0,33.23V0h141.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.0728802825f1843fe36271f13770e863.svg";
export { ForwardRef as ReactComponent };